import { render, staticRenderFns } from "./DMVFee.vue?vue&type=template&id=23c1ab3b&"
import script from "./DMVFee.vue?vue&type=script&lang=js&"
export * from "./DMVFee.vue?vue&type=script&lang=js&"
import style0 from "./DMVFee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DMVFee.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/DMVFee.vue
// module id = null
// module chunks = 